import { initModule } from './init-module';

initModule();

export { InsuranceGlossaryRoutes } from './insurance-glossary.routes';

export { glossary } from './insurance-glossary.config';

export { GlossaryComponent } from './components/glossary';
